/**
 * HM-418..421 cluster 21 Clienti CRM — client API.
 */
import { api } from './client.js';

export type GuestListItem = {
  id: string;
  firstName: string;
  lastName: string;
  email: string | null;
  phone: string | null;
  isVip: boolean;
  internalNotes: string | null;
  staysCount: number;
  lastStayAt: string | null;
  totalSpent: string | number;
};

export type GuestListResponse = {
  items: GuestListItem[];
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type GuestDetail = {
  guest: {
    id: string;
    firstName: string;
    lastName: string;
    email: string | null;
    phone: string | null;
    isVip: boolean;
    internalNotes: string | null;
    nationality: string | null;
    documentType: string | null;
    documentNumber: string | null;
    notes: string | null;
    createdAt: string;
    updatedAt: string;
  };
  bookings: Array<{
    id: string;
    publicCode: string;
    roomId: string | null;
    service: string;
    status: string;
    startAt: string;
    endAt: string;
    totalAmount: string;
    paidAmount: string;
    extraAmount: string;
  }>;
  stats: {
    staysCount: number;
    totalSpent: string;
    firstStayAt: string | null;
    lastStayAt: string | null;
  };
};

export type DuplicateGroup = {
  phone: string;
  count: number;
  guests: Array<{
    id: string;
    firstName: string;
    lastName: string;
    email: string | null;
    isVip: boolean;
  }>;
};

export async function listGuests(opts: {
  search?: string;
  page?: number;
  pageSize?: number;
  vipOnly?: boolean;
}): Promise<GuestListResponse> {
  const qs = new URLSearchParams();
  if (opts.search) qs.set('search', opts.search);
  if (opts.page) qs.set('page', String(opts.page));
  if (opts.pageSize) qs.set('pageSize', String(opts.pageSize));
  if (opts.vipOnly) qs.set('vipOnly', '1');
  return api(`/guests${qs.size > 0 ? `?${qs.toString()}` : ''}`);
}

export async function getGuestDetail(id: string): Promise<GuestDetail> {
  return api(`/guests/${id}`);
}

export async function patchGuest(
  id: string,
  patch: { isVip?: boolean; internalNotes?: string | null },
): Promise<{ guest: GuestDetail['guest'] }> {
  return api(`/guests/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}

export async function listDuplicates(): Promise<{ duplicates: DuplicateGroup[] }> {
  return api('/guests/duplicates');
}
